// Note: nanosecond timestamps (~1.77e18) exceed Number.MAX_SAFE_INTEGER (~9e15).
// Precision loss is negligible for date-range filtering (whole seconds from DatePicker).
// If exact ns precision is needed, switch to BigInt and update Cloud Function validation.
export function dateToNs(date: Date): number {
    return date.getTime() * 1_000_000;
}

export function nsToDate(ns: string | number): Date {
    return new Date(Number(BigInt(ns) / 1_000_000n));
}
